import { useTranslation } from 'react-i18next'
import image from '../assets/images/Olga1.jpg'

export default function HeroBanner() {
  const { t } = useTranslation()
  return (
    <section className='flex justify-center pb-12 lg:py-24'>
      <div className='w-[92%] lg:w-5/6 flex flex-col xl:flex-row items-center gap-8 2xl:gap-16'>
        <div className='w-full md:w-2/3 2xl:w-1/3'>
          <img
            alt='Olga Avatar'
            src={image}
          />
        </div>
        <div className='w-full xl:w-3/5 2xl:w-2/3'>
          <div className='w-full lg:mb-0'>
            <h1 className='sm:text-3xl text-xl drop-shadow-md sm:mb-2 font-[900] uppercase'>
              {t('heroSection.title')}
            </h1>
            <div className='h-1 w-20 bg-gradient-to-r  from-green-500 to-blue-600 rounded-full'></div>
          </div>
          <h1 className='mt-2 sm:mt-4 text-lg sm:text-xl text-gray-600 drop-shadow-md font-normal'>
            {t('heroSection.content')}
          </h1>
        </div>
      </div>
    </section>
  )
}
